import getDefaults from './cookie-settings';
import {trackEvent} from './tracking';

const clickableElements = new Set;

export const makeElementsClickable = ({
                                          selector,
                                          containerElement,
                                          callback,
                                      }) => {
    const elements = containerElement.querySelectorAll(selector);

    [...elements].forEach(element => {
        if (!clickableElements.has(element)) {
            element.addEventListener('click', callback);
            clickableElements.add(element);
        }
    });
};

export const getConfig = overrides => {
    const defaults = getDefaults();
    const itemIdSet = new Set;
    const config = {
        theme: defaults.theme,
        default_preset: defaults.default_preset,
        strings: defaults.strings,
    };
    let presetValue = true;

    //TODO: make config overrideable

    Object.keys(defaults.presets).forEach(presetId => {
        const preset = {
            ...defaults.presets[presetId],
            id: presetId,
            value: !!presetValue,
        };

        Object.keys(defaults.items).forEach(itemId => {
            if (!itemIdSet.has(itemId) && defaults.items[itemId].enabled && defaults.items[itemId].level[presetId]) {
                preset.items = [...preset.items || [], {
                    ...defaults.items[itemId],
                    id: itemId,
                    value: !!presetValue,
                }];
                itemIdSet.add(itemId);
            }
        });

        config.presets = [...config.presets || [], preset];

        if (presetValue && presetId === defaults.default_preset) {
            presetValue = false;
        }
    });

    return config;
};

export const setPresetValue = ({
                                   currentValue,
                                   presetId,
                                   value,
                               }) => {
    const presetIndex = currentValue.presets.map(x => x.id).indexOf(presetId);

    if (currentValue.presets[presetIndex]) {
        currentValue.presets[presetIndex].value = value;

        if (currentValue.presets[presetIndex]?.items?.length) {
            currentValue.presets[presetIndex].items.forEach((item, itemIndex) => {
                currentValue.presets[presetIndex].items[itemIndex].value = value;
            });
        }
    }

    return currentValue;
};

export const setItemValue = ({
                                 currentValue,
                                 presetId,
                                 itemId,
                                 value,
                             }) => {
    const presetIndex = currentValue.presets.map(x => x.id).indexOf(presetId);
    const itemIndex = currentValue.presets[presetIndex].items.map(x => x.id).indexOf(itemId);

    if (currentValue.presets[presetIndex].items[itemIndex]) {
        currentValue.presets[presetIndex].items[itemIndex].value = value;
    }

    return currentValue;
};

export const setCookie = (name, value) => {
    const yearInMilliseconds = 365 * 24 * 60 * 60 * 1000;
    const date = new Date();
    let cookieString;

    date.setTime(date.getTime() + yearInMilliseconds);
    cookieString = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/; samesite=lax';

    if (!(window.location.hostname.indexOf('localhost') !== -1)) {
        cookieString += '; secure';
    }

    document.cookie = cookieString;
};

export const readCookie = name => {
    return document.cookie.split(';').filter((item) => {
        return item.indexOf(name + '=') >= 0;
    });
};

export const saveState = state => {
    state.presets.forEach(preset => {
        preset.items.forEach(item => {
            setCookie(`script_allowed_${item.id}`, item.value);

            if (['analytics'].includes(item.id)) {
                updateConsent('analytics_storage', item.value ? 'granted' : 'denied');
            }

            if (['doubleclick', 'outbrain', 'taboola'].includes(item.id)) {
                updateConsent('ad_storage', item.value ? 'granted' : 'denied');
                updateConsent('ad_user_data', item.value ? 'granted' : 'denied');
                updateConsent('ad_personalization', item.value ? 'granted' : 'denied');
            }

            trackEvent({
                category: 'e_consent__saved',
                action: item.id,
                label: item.value,
                eventIsNonInteraction: false,
            });
        });
    });
};

export const loadState = config => {
    let allItemsFound = true;

    config.presets.forEach((preset, presetIndex) => {
        let allPresetItemsFound = true;
        let hasEnabledItem = false;
        let isEmpty = false;

        preset.items = preset.items || [];

        if (preset.items.length) {
            preset.items.forEach((item, itemIndex) => {
                if (readCookie(`script_allowed_${item.id}`)[0]?.includes('true')) {
                    // enable if cookie contains true
                    config.presets[presetIndex].items[itemIndex].value = true;
                    hasEnabledItem = true;
                } else if (readCookie(`script_allowed_${item.id}`)[0]?.includes('false')) {
                    // disable if cookie contains false
                    config.presets[presetIndex].items[itemIndex].value = false;
                } else {
                    // leave as-is in config if cookie contains neither true or false or is undefined
                    allPresetItemsFound = false;
                }
            });
        } else {
            // preset empty
            isEmpty = true;
        }

        // enable preset when at least one item of preset is enabled and all items where found in cookies
        if (isEmpty) {
            config.presets[presetIndex].value = presetIndex === 0 ? true : hasEnabledItem;
        } else if (allPresetItemsFound) {
            config.presets[presetIndex].value = hasEnabledItem;
        } else {
            allItemsFound = false;
        }
    });

    // display consent if not all items were found
    config.display = !allItemsFound;

    return config;
};

export const ensureGtagFunc = () => {
    window.dataLayer = window.dataLayer || [];

    if (typeof window.gtag !== 'function') {
        window.gtag = function () {
            dataLayer.push(arguments);
        };
    }
};

export const updateConsent = (key, value) => {
    const item = {};

    item[key] = value;
    ensureGtagFunc();
    gtag('consent', 'update', item);
};
